// eslint-disable-next-line import/no-anonymous-default-export

import { PAI } from "../utils/RouteHelper/IBP/PAI";
import { SNOP } from "../utils/RouteHelper/IBP/SNOP";
import { SNOE } from "../utils/RouteHelper/IOP/SNOE";
/* 
List of All the literals and constants used in Project
*/
const constKeys = {
  api: "",
  API_METHOD_POST: "POST",
  API_METHOD_GET: "GET",
  API_METHOD_PUT: "PUT",
  API_METHOD_PATCH: "PATCH",
  API_METHOD_DELETE: "DELETE",
  API_METHOD_HEAD: "HEAD",
  FORM_VALIDATION_EXAMPLE: "Form Inputs Validation Example",
  ERROR_BOUNDARY_EXAMPLE: "Error Boundary Example",
  API_RESPONSE_ERROR: "Something went wrong with API",
  GLOBAL_ERROR: "Something went wrong",
};

export const supportedLanguage = ["en-US", "tr", "nl-NL", "ko-KR"];

export const languageLabels = {
  "en-US": "English (US)",
  en: "English (US)",
  tr: "Turkish (TR)",
  "tr-TR": "Turkish (TR)",
  "nl-NL": "Dutch (NL)",
  nl: "Dutch (NL)",
  "ko-KR": "Korean (KR)",
  ko: "Korean (KR)",
};

export const adminType = {
  "3SCAdmin": "3SCAdmin",
  "Client Admin": "Client Admin",
};

// "Thousand Style" options for the profile menu. The stored token is plural
// ("millions"/"lakhs"); the dpai remote reads it back and divides displayed
// values by 1,000,000 (millions) or 100,000 (lakhs). A business unit's own
// configuration.locale.thousandsGroupStyle may still be singular
// ("million"/"lakh"), so normalizeThousandStyle folds both onto the plural form.
// "default" is an explicit choice meaning "show raw, unscaled values": it is
// stored so it overrides the BU config default (the remote reads it back with
// ??, so it is NOT replaced by configuration.locale.thousandsGroupStyle), and
// because it is not lakhs/millions the remote applies no divisor and shows no
// thousand-style suffix in the dashboard.
export const THOUSAND_STYLE = {
  default: "default",
  millions: "millions",
  lakhs: "lakhs",
};

export const supportedThousandStyles = [
  THOUSAND_STYLE.default,
  THOUSAND_STYLE.millions,
  THOUSAND_STYLE.lakhs,
];

export const thousandStyleLabels = {
  [THOUSAND_STYLE.default]: "Default",
  [THOUSAND_STYLE.millions]: "Millions",
  [THOUSAND_STYLE.lakhs]: "Lakhs",
};

export const normalizeThousandStyle = (token) => {
  if (token === "lakh" || token === "lakhs") return THOUSAND_STYLE.lakhs;
  if (token === "million" || token === "millions") return THOUSAND_STYLE.millions;
  if (token === THOUSAND_STYLE.default) return THOUSAND_STYLE.default;
  return token || "";
};

export const createThemeSelect = (theme) => {
  return {
    ...theme,
    borderRadius: 2,
    colors: {
      ...theme.colors,
      primary25: "#F2F2F2",
      primary: "#E94F1C",
    },
  };
};

export const userEditInitialValues = {
  organization: "",
  first_name: "",
  last_name: "",
  email: "",
  mobile_country_code: "",
  mobile: "",
  team: "",
  business_unit: "",
  address_line1: "",
  address_line2: "",
  country: null,
  state: null,
  city: null,
  pincode: "",
  roles: "",
};

export const getInTouch = {
  firstName: "",
  lastName: "",
  email: "",
  mobile: "",
  organization: "",
  designation: "",
  date: "",
  time: "",
};

export const phoneInputValidateMsg = "This field is mandatory";
export const activateSNOPMessage = "Activate the SNOP to access";
export const activateSNOEMessage = "Activate the S&OE to access";
export const ENABLE_FOR_MENU = [SNOP.name, PAI.name, SNOE.name, "Setup"];
export const nameValidation = [
  "required",
  "alpha_num_dash_space",
  { max: "64" },
];
export const APPBAR_MENU = {
  IBP: "Integrated Business Planning",
  EDM: "Enterprise Data Management",
  DTRM: "Risk Management & Digital Twin",
  ID: "Internal Dashboard",
  CX: "CarbonX",
  DH: "Data Health",
  GENAI: "Cortex",
  IOP: "Integrated Operations Planning",
};
export default constKeys;

export const colorPalette = {
  grey: "#72757a",
  green: "#1BD365",
};

export const menuRoutes = [
  {
    name: "Home",
    path: "",
    isNavigate: false,
  },
  {
    name: "About",
    path: "https://3scsolution.com/about-us",
    isNavigate: true,
  },
  {
    name: "Features",
    path: "features",
    isNavigate: false,
  },
  {
    name: "How it works?",
    path: "works",
    isNavigate: false,
  },
];

export const CLIENT_PERMISSIONS = [
  "BU_VIEWCONFIGURATION",
  "CLIENT_CREATEEDITCONFIGURATION",
  "ROLE_EDIT",
  "CLIENT_VIEWCONFIGURATION",
  "TEAM_CREATE",
  "USER_CREATE",
  "ROLE_CREATE",
  "ROLE_VIEW",
  "USER_VIEW",
  "TEAM_VIEW",
  "BU_CREATE",
  "BU_CREATEEDITCONFIGURATION",
  "TEAM_EDIT",
  "USER_EDIT",
  "BU_EDIT",
  "BU_VIEW",
];

export const SCAIFrontendParams = {
  ID: {
    id: "admin",
    name: "admin",
    host: import.meta.env.VITE_ADMIN_HOST,
    requireAuth: true,
    federated: true,
  },
  DPAI: {
    id: "dpai",
    name: "dp",
    host: import.meta.env.VITE_DPAI_HOST,
    requireAuth: true,
    federated: true,
  },
  DS_DASHBOARD: {
    // Was id/name "ds", identical to the DSAI entry below — the two remotes
    // silently collided on both the mount container id and the
    // window.render<name>/createRoot<name> lookup MicroFrontend.jsx uses.
    // DSAI keeps "ds" since it's the one being migrated to Module
    // Federation; this one (a different remote, VITE_DS_HOST) gets its own
    // identifier.
    id: "ds-dashboard",
    name: "ds-dashboard",
    host: import.meta.env.VITE_DS_HOST,
    requireAuth: true,
  },
  DT: {
    id: "dt",
    name: "dt",
    host: import.meta.env.VITE_DT_HOST,
  },
  EDM: {
    id: "edm",
    name: "edm",
    host: import.meta.env.VITE_EDM_HOST,
    federated: true,
  },
  GENAI: {
    id: "gen-ai",
    name: "gen-ai",
    host: import.meta.env.VITE_GENAI_HOST,
  },
  DH: {
    id: "health",
    name: "health",
    host: import.meta.env.VITE_HEALTH_HOST,
  },
  PAI: {
    id: "product",
    name: "pp",
    host: import.meta.env.VITE_PRODUCT_HOST,
  },
  RM: {
    id: "riskai",
    name: "riskai",
    host: import.meta.env.VITE_RM_HOST,
  },
  SNOE: {
    id: "snoe",
    name: "snoe",
    host: import.meta.env.VITE_SNOE_HOST,
    federated: true,
  },
  SNOP: {
    id: "snop",
    name: "snop",
    host: import.meta.env.VITE_SNOP_HOST,
    federated: true,
  },
  SNP: {
    id: "snp",
    name: "snp",
    host: import.meta.env.VITE_SNP_HOST,
    federated: true,
  },
  TMS: {
    id: "tms",
    name: "tms",
    host: import.meta.env.VITE_TMS_HOST,
    entry: "/src/main.tsx",
    federated: true,
  },
  IEO: {
    id: "ieo",
    name: "ieo",
    host: import.meta.env.VITE_IEO_HOST,
    federated: true,
  },
  SS: {
    id: "rs",
    name: "rs",
    host: import.meta.env.VITE_SS_HOST,
    federated: true,
  },
  DSAI: {
    id: "ds",
    name: "ds",
    host: import.meta.env.VITE_DSAI_HOST,
    federated: true,
  },
  CORTEX: {
    id: "cortex",
    name: "cortex",
    host: import.meta.env.VITE_CORTEX_HOST,
  },
  INTEGRATION: {
    id: "integration",
    name: "integration",
    host: import.meta.env.VITE_INTEGRATION_HOST,
    entry: "/src/main.tsx",
    federated: true,
  },
};

export const AUTH_SCREENS = {
  LOGIN: "login",
  FORGOT_PASSWORD: "forgot_password",
  RESET_PASSWORD: "reset_password", // NOSONAR - UI route identifier, not a credential
  EMAIL_SENT: "email_sent",
};

export const LANGUAGES = ["English", "Spanish", "French", "German", "Japanese"];

export const FOOTER_YEAR = 2026;
